import * as React from 'react'

import {
  AttendanceEmployeePoliciesDocument,
  AttendanceEmployeePoliciesQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

interface ContextProps {
  loading: boolean
  data: AttendanceEmployeePoliciesQuery['attendance'] | undefined
  attendanceEmployeesPolicyId: string | null | undefined
}

const Context = React.createContext<ContextProps>({
  loading: false,
  data: undefined,
  attendanceEmployeesPolicyId: undefined,
})

export const AttendancePoliciesProvider = ({
  employeeId,
  children,
}: {
  employeeId: string | undefined
  children: React.ReactNode
}) => {
  const { data, loading } = useQuery(AttendanceEmployeePoliciesDocument, {
    variables: { id: employeeId ?? '0' },
  })

  return (
    <Context.Provider
      value={{
        loading,
        data: data?.attendance,
        attendanceEmployeesPolicyId: data?.attendance?.employee?.attendanceEmployeesPolicyId,
      }}
    >
      {children}
    </Context.Provider>
  )
}

export const useAttendancePolicies = (): ContextProps => {
  const attendancePolicies = React.useContext(Context)

  if (!attendancePolicies) {
    throw new Error('useAttendancePolicies must be used within a AttendancePoliciesProvider')
  }

  return attendancePolicies
}
